export const convertDateToUTC = (date) => {
    if (!date) {
        return null;
    }

    const originalDate = new Date(date);
    if (originalDate.getUTCHours() !== 0) {
        const convertedDate = new Date(originalDate.getTime() - (originalDate.getTimezoneOffset() * 60000));
        return convertedDate.toISOString();
    }
    return originalDate.toISOString();
}
